var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgM2CCurrentVersionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90106 11.5556H5.05556C4.11217 11.5556 3.30961 10.9526 3.01218 10.1111H2.16667C0.970053 10.1111 0 9.14109 0 7.94444V5.05556C0 3.85894 0.970053 2.88889 2.16667 2.88889H3.01218C3.30961 2.04736 4.11217 1.44444 5.05556 1.44444H5.90106C6.19847 0.602918 7.00108 0 7.94444 0H12.2778C13.4744 0 14.4444 0.970053 14.4444 2.16667V10.8333C14.4444 12.03 13.4744 13 12.2778 13H7.94444C7.00108 13 6.19847 12.3971 5.90106 11.5556ZM5.77778 2.88889H5.05556C4.65669 2.88889 4.33333 3.21224 4.33333 3.61111V9.38889C4.33333 9.78777 4.65669 10.1111 5.05556 10.1111H5.77778V2.88889ZM7.22222 2.16667C7.22222 1.7678 7.54556 1.44444 7.94444 1.44444H12.2778C12.6767 1.44444 13 1.7678 13 2.16667V10.8333C13 11.2322 12.6767 11.5556 12.2778 11.5556H7.94444C7.54556 11.5556 7.22222 11.2322 7.22222 10.8333V2.16667ZM2.88889 4.33333V8.66667H2.16667C1.7678 8.66667 1.44444 8.34333 1.44444 7.94444V5.05556C1.44444 4.65669 1.7678 4.33333 2.16667 4.33333H2.88889Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM2CCurrentVersionIcon);
export default __webpack_public_path__ + "static/media/m2c_current_version_icon.96f9ac674251661e03e28a7abfe26761.svg";
export { ForwardRef as ReactComponent };